module.exports = __webpack_public_path__ + "static/media/Batteries _lightduty_xparent.64c244b5.png";